import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import { useTopic } from "../../../hooks/useTopic";
import { useSectionRefs } from "../../../hooks/useSectionRefs";
import TagsAnchorContainer from "../TagsAnchorContainer";

const HelpTopicQueues = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  // const { topic, isLoading, LoadingComponent } = useTopic();
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;

  const goBackLinks = [
    { label: 'Accueil', link: '/' },
    { label: 'Tous les sujets', link: '/topics' },
    { label: 'Vos inscriptions', link: '/topics/inscription' },
    { label: topic.title, link: topic.link },
  ];

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">{topic.description}</p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{topic.subtitles[0]}</p>
              <p className="help-text">
                Les participants sont ajoutés à la file d'attente selon <strong>l'ordre d'inscription</strong>. 
                Vous recevrez un e-mail de confirmation indiquant votre position dans la liste.
                Vous pouvez à tout moment consulter{' '}
                <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/account-settings/events`}>
                  vos inscriptions ici.
                </a>
              </p>
              <p className="help-text">
                Il est possible de rejoindre plusieurs files d'attente pour différentes catégories d'un même événement.
                Cependant, dès qu'une inscription est validée, <strong>toutes vos autres demandes en attente pour cet événement sont automatiquement annulées</strong>.
              </p>
              <p className="help-text">
                Cette règle garantit une équité entre les participants : chacun a sa chance de décrocher une place.
                Par ailleurs, il n'est pas possible de rejoindre une file d'attente si vous êtes déjà inscrit à cet événement.
              </p>
              <p className="help-text mt-24">
                En rejoignant une file d'attente, vous acceptez de recevoir des SMS de la part de WodZone.
              </p>
            </div>
            <div className="article-container mt-40" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{topic.subtitles[1]}</p>
              <p className="help-text mt-24">
                Dès qu'une place se libère, le premier de la liste reçoit une notification par <strong>SMS et par e-mail</strong>,
                avec un lien sécurisé valable <strong>24h</strong> pour finaliser son inscription.
                Il suffit de cliquer sur le bouton dans l'e-mail et de suivre les étapes.
              </p>
              <p className="help-text mt-24">
                Rappel : si votre inscription est validée, vos autres demandes en file d'attente pour cet événement seront automatiquement annulées.
              </p>
              <p className="help-text mt-24">
                Sans confirmation dans ce délai de 24h — ou en cas de refus — la place sera automatiquement proposée à la personne suivante.
                Vous pourrez vous réinscrire en file d'attente, mais vous serez placé en dernière position.
                En cas de problème durant ce créneau, nous vous invitons à nous
                <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/contact`}>
                  contacter immédiatement.
                </a>
                Selon la situation, un délai supplémentaire pourra être accordé.
              </p>
              <p className="help-text mt-24">
                Vous serez également notifié par e-mail à chaque évolution de votre position dans la liste.
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic} />
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  );
};

export default HelpTopicQueues